import { faBell, faRss } from "@fortawesome/free-solid-svg-icons";
import { PlusIcon } from "@heroicons/react/solid";
import React from "react";
import { SideBarStates } from "../../../context/SidebarContext";
import { BasePanelComponent } from "./CommonComponents";

const FeedItems = [
  { name: "Today", active: true, count: 10 },
  { name: "Read Later", active: false, count: 1 },
  { name: "All", active: false, count: 0 },
  { name: "Favorites", active: false, count: 0 },
];

export function RssFeedPanel() {
  return (
    <BasePanelComponent openState={SideBarStates.RSSFeed}>
      <BasePanelComponent.Header
        title="Feed Reader"
        iconName={faRss}
        content={
          <div>
            <PlusIcon className="h-8 w-8 text-teal-600" />
          </div>
        }
      ></BasePanelComponent.Header>
      <BasePanelComponent.Body className="w-screen max-w-md">
        <div className="relative flex-1 overflow-hidden flex flex-col">
          <div className="resize-y shadow-inner border-t border-b  max-h-full overflow-y-scroll">
            {FeedItems.map((item) => {
              return (
                <FeedItem
                  key={item.name}
                  onClick={() => {}}
                  count={item.count}
                  title={item.name}
                  active={item.active}
                />
              );
            })}
          </div>
        </div>
        <div className="p-3 w-full flex justify-center items-center border-b">
          <div>
            <p className="text-teal-600 text-lg">+ ADD FEED</p>
          </div>
        </div>
        <div className="p-4 w-full flex justify-start items-center border-b bg-teal-050">
          <div>TODAY</div>
        </div>
        <div className=" flex flex-col flex-1 justify-center items-center">
          <div className="mt-6 gap-y-4 flex flex-col justify-center items-center">
            <h2 className="text-2xl">All Caught Up!</h2>
            <h3 className="text-xl">You have no undread articles.</h3>
          </div>
        </div>
      </BasePanelComponent.Body>
    </BasePanelComponent>
  );
}

function FeedItem({
  onClick,
  count,
  title,
  active = false,
}: {
  onClick: React.MouseEventHandler<HTMLDivElement>;
  count?: number;
  title: string;
  active: boolean;
}) {
  return (
    <div className="relative flex-col flex flex-1 justify-center">
      <div
        onClick={onClick}
        className={`py-3 pl-3 pr-5 flex flex-1 justify-between hover:bg-eggShell hover:text-hyperLink ${
          active === true ? "bg-teal-050 text-hyperLink" : ""
        }`}
      >
        {active === true && (
          <div className="absolute top-0 bottom-0 w-1 left-0 bg-teal-700" />
        )}
        <div className="flex items-center">
          <div>{title}</div>
        </div>
        <div>{count ?? 0}</div>
      </div>
    </div>
  );
}
